import { render, staticRenderFns } from "./OrderReceivable.vue?vue&type=template&id=f46af5c0&scoped=true&"
import script from "./OrderReceivable.vue?vue&type=script&lang=js&"
export * from "./OrderReceivable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f46af5c0",
  null
  
)

export default component.exports